const styles = (theme) => ({
  accordion: {
    margin: 0,
    '&:before': {
      height: 0,
    },
  },
  accordionSummary: {
    '.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
    padding: 0,
    backgroundColor: theme.palette.background.paper,
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    borderColor: 'transparent',
    '.MuiAccordionSummary-content': {
      marginLeft: '16px',
    },
    '.Mui-expanded': {
      marginTop: '12px',
      marginBottom: '12px',
    },
  },
  accordionDetails: {
    padding: '0px 32px',
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
  termsLink: {
    textDecorationLine: 'none',
    color: theme.palette.primary.main,
    display: 'inline-flex',
    alignItems: 'center',
    '&:hover': {
      textDecorationLine: 'underline',
    },
  },
});

export default styles;
